let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6l70P")).then(() => parcelRequire('c6bSy'));